const newsData = {
  notice: [
    {
      id: 1,
      type: "공지",
      date: "2025-12-10",
      title: "상대아이파크점 Grand Open! (12월 10일)",
    },
    {
      id: 2,
      type: "공지",
      date: "2025-11-07",
      title: "전주서신점 Grand Open! (11월 6일)",
    },
    {
      id: 3,
      type: "공지",
      date: "2025-10-01",
      title: "창동역점 Grand Open! (9월 25일)",
    },
    {
      id:7,
      type: "공지",
      date: "2025-09-28",
      title: "천호역점 Grand Open! (9월 28일)",
    },
  ],
  press: [
    {
      id: 4,
      type: "기사",
      date: "2025-09-15",
      title: "맛닭꼬, 합리적인 가격으로 가맹 확장 가속",
    },
    {
      id: 5,
      type: "기사",
      date: "2025-08-20",
      title: "치킨 프랜차이즈 시장에서 맛닭꼬의 성장 전략",
    },
    {
      id: 6,
      type: "기사",
      date: "2025-08-15",
      title: "치킨계의 독립투사 맛닭꼬!!!",
    },
    {
      id: 8,
      type: "기사",
      date: "2025-08-10",
      title: "무더위에는 역시 치킨이 맛닭꼬",
    },
  ],
};

export default newsData;
